import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { useEffect } from 'react';

const DEFAULT_BASIC_DETAILS = {};

const useJbEventFBViewPDP = (basicDetails = DEFAULT_BASIC_DETAILS) => {
  const { sku = '', name = '' } = basicDetails;
  useEffect(() => {
    if (sku && name) {
      window.jbEventFBViewPDP = () => {
        sendFBEvent(FB_EVENTS.VIEW_PDP, {
          content_ids: [sku.split('-')?.[0]],
          content_name: name,
          content_type: 'product',
        });
      };
    } else {
      window.jbEventFBViewPDP = undefined;
    }
  }, [name, sku]);
};

export default useJbEventFBViewPDP;
